import React, { useState, useEffect } from 'react'
import { FormGroup, ControlLabel, Input, Radio, RadioGroup } from 'rsuite'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'

export default function ApproveProposalForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
  onSelect = () => {},
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <FormGroup>
        <ControlLabel
          className={classNames(
            'style-text-lable',
            isRequired(schema.remark.validators) && 'required'
          )}
        >
          {schema.remark.label}
        </ControlLabel>
        <ErrorMessage error={errors.remark} />
        <Input
          name={schema.remark.name}
          defaultValue={schema.remark.value || ''}
          componentClass="textarea"
          placeholder={schema.remark.label}
          inputRef={register(isValidators(schema.remark.validators))}
          disabled={schema.disabled}
        />
      </FormGroup>

      {schema.approveProposal && (
        <Controller
          name={schema.approveProposal.name}
          control={control}
          defaultValue={schema.approveProposal.value || 1}
          rule={register(isValidators(schema.approveProposal.validators))}
          render={(props) => {
            return (
              <RadioGroup
                value={props.value}
                onChange={(value) => {
                  props.onChange(value)
                  onSelect(value)
                }}
              >
                {schema.approveProposal.options.map((item) => (
                  <Radio key={item.value} value={item.value} disabled={schema.disabled}>
                    {item.label}
                  </Radio>
                ))}
              </RadioGroup>
            )
          }}
        />
      )}
    </>
  )
}
